<template>
  <el-dialog
    class="dialog"
    center
    width="550px"
    v-loading="loading"
    :append-to-body="append"
    :close-on-click-modal="false"
    :visible.sync="hostVisible">
    <template #title>
      <div class="font">请选择要登录的账号</div>
      <div>当前微信关联{{count}}个账号，请选择账号登录</div>
    </template>
    <div style="padding-bottom:50px;">
      <choose-comp @complete="completeWebLogin" v-for="item in enterpriseList" :enterpriseItem="item" :key="item.dpuid"/>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import Login from 'service/login'
import ChooseComp from './ChooseComp.vue'
import bus from '../../help/bus'
export default {
  name: 'ModalChoose',
  components: {
    ChooseComp
  },
  props: {
    append: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isFromSwitchAccount: false, // 区分是不是来自于【切换账号】功能
      hostVisible: false,
      loading: false,
      url: require('@/assets/imgs/touxiang.png')
    }
  },
  computed: {
    ...mapState([
      'enterpriseList'
    ]),
    count() {
      return this.enterpriseList.length
    }
  },
  methods:{
    ...mapMutations({
      setIsLogin: 'SET_ISLOGIN',
      setEnterpriseId: 'SET_ENTERPRISE_ID'
    }),
    ...mapActions([
      'logout',
      // 'getOpenAccountInfo'
    ]),
    completeWebLogin (dpuid, enterpriseId) {
      bus.$emit('changeImg', enterpriseId)
      const eidItem = this.enterpriseList.find(item => {
        return item.dpuid === dpuid
      })
      if (!eidItem) return
      this.loading = true
      Login.completeWebLogin(eidItem.enterpriseId).then(() => {
        this.hostVisible = false
        this.loading = false
        this.$emit('close')
        this.setEnterpriseId(enterpriseId)
        // return this.getOpenAccountInfo()
      }).then((accountInfo) => {
        if (accountInfo) {
          let msg = this.isFromSwitchAccount ? '切换账号成功' : '登录成功'
          this.$message({
            message: msg,
            type: 'success'
          })
          this.setIsLogin(true)
          this.$router.push('/space/index')
        }
      }).catch(error => {
        this.$message({
          message: '获取账户信息失败,登录失败',
          type: 'warning'
        })
        this.hostVisible = false
        this.loading = false
        console.error(error)
      })
    },
    choose (isFromSwitchAccount = false) {
      this.isFromSwitchAccount = isFromSwitchAccount
      if (this.count === 1) {
        this.completeWebLogin(this.enterpriseList[0].dpuid, this.enterpriseList[0].enterpriseId)
        return
      }
      this.hostVisible = true
      console.log(this.hostVisible)
    }
  }
}
</script>

<style lang="scss" scoped>
  .dialog{
    /deep/ .el-dialog--center .el-dialog__body{
      background: $background;
      margin-top: 10px;
      border-radius:0 0 16px 16px;
    }
    /deep/ .el-dialog{
      background: $background;
    }
  }
   .dialog{
     /deep/ .el-dialog__header{
      border-radius: 16px 16px 0 0;
      padding: 10px 0 !important;
      color: white;
      background: $sub-color;
      //  margin-bottom: 10px;
     }
   }
  .font{
    font-size: 24px;
    font-weight: 600;
    margin-bottom: 10px;
  }
</style>
